export default [
  {
    path: "/document",
    name: "document",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Журнал документов",
      permissions: ["document:index"],
    },
  },
];
